import { URL_CONFIG } from "./urlConfig";

export const ATP_API_URL = {
  // ATP Auth APIs
  LOGIN: `${URL_CONFIG.ATP_API_BASE_URL}auth/login`,
  VERIFY_OTP: `${URL_CONFIG.ATP_API_BASE_URL}auth/validateOtp`,
  RESEND_OTP: `${URL_CONFIG.ATP_API_BASE_URL}auth/resend-otp`,

  GET_ALL_DASHBOARD_DATA: `${URL_CONFIG.ATP_API_BASE_URL}users/lobDashboardData`,
  UPDATE_PASSWORD: `${URL_CONFIG.ATP_API_BASE_URL}users/ResetPassword`,
  GET_ALL_POLICIES: `${URL_CONFIG.ATP_API_BASE_URL}users/policies`,
  GET_ALL_CLAIMS: `${URL_CONFIG.ATP_API_BASE_URL}users/claims`,
  CLAIM_DECISION: `${URL_CONFIG.ATP_API_BASE_URL}users/ClaimDecision`,
  GET_ALL_CDBALANCE: `${URL_CONFIG.ATP_API_BASE_URL}users/cdBalance`,
  ADD_CD_BALANCE: `${URL_CONFIG.ATP_API_BASE_URL}users/add-cdBalance`,
  VERIFY_ADD_CD_BALANCE: `${URL_CONFIG.ATP_API_BASE_URL}users/verify-cdBalance-otp`,
  GET_ALL_VOUCHER_DETAILS: `${URL_CONFIG.ATP_API_BASE_URL}users/vouchers`,
  UPLOAD_EXCEL_SHEET_DATA: `${URL_CONFIG.ATP_API_BASE_URL}users/update_cdBalance_excel`,
  GET_PREMIUM_CD_BALANCE: `${URL_CONFIG.ATP_API_BASE_URL}users/premiumCdBalance`,

  // Client Management APIs
  GET_ALL_CLIENTS: `${URL_CONFIG.ATP_API_BASE_URL}users/clients`,
  CREATE_CLIENT: `${URL_CONFIG.ATP_API_BASE_URL}users/create-client`,
  UPDATE_CLIENT: `${URL_CONFIG.ATP_API_BASE_URL}users/UpdateClientStatus`,
  DELETE_CLIENT: `${URL_CONFIG.ATP_API_BASE_URL}users/client`,

  // MIS Reports API Endpoints
  MIS_TRAIN_PERFORMANCE: `${URL_CONFIG.ATP_API_BASE_URL}users/train-wise-performance`,
  MIS_REVENUE: `${URL_CONFIG.ATP_API_BASE_URL}users/revenue-summary`,
  MIS_OTA_PARTNER: `${URL_CONFIG.ATP_API_BASE_URL}users/ota-partner-performance`,
  MIS_PROBABILITY_MONITORING: `${URL_CONFIG.ATP_API_BASE_URL}users/probability-audit`,
  MIS_ACTIVE_JOURNEY: `${URL_CONFIG.ATP_API_BASE_URL}users/journeys/active`,
};
